import { useEffect, useState } from 'react'
import Router from 'next/router'
import { useDispatch, useSelector } from 'react-redux'
import { useUser } from '../hooks'
import { clearErrors, requestSignup } from '../redux/actions'
import Button from '../components/Button'
import Input from '../components/Input'

const SignupPage = () => {
  const dispatch = useDispatch()
  const serverErrors = useSelector((state) => state.errors)
  const [email, setEmail] = useState()
  const [clientErrors, setClientErrors] = useState(serverErrors)
  const [password, setPassword] = useState()
  const [username, setUsername] = useState()
  const [verify, setVerify] = useState()
  const [loading, setLoading] = useState(false)

  const [user, { mutate }] = useUser()

  const errors = {
    ...clientErrors,
    ...serverErrors,
  }

  useEffect(() => {
    if (user) Router.push('/')
  }, [user])

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (valid()) {
      dispatch(
        requestSignup({
          email,
          password,
          username,
          verify,
          cb: (body) => mutate(body),
        })
      )
    }
  }

  const valid = () => {
    const newErrors = {}
    if (
      !/^[_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]+)*$/i.test(
        email
      )
    ) {
      newErrors.email = 'Invalid email'
    }

    if (password !== verify) {
      newErrors.verify = 'Your passwords do not match'
    }
    if (username.length < 2 || username.length > 20) {
      newErrors.username = 'Your username must be between 2 and 20 characters'
    }
    if (password.length < 6) {
      newErrors.password = 'Your password must be between 6 and 20 characters'
    }

    if (
      Object.keys(newErrors).length === 0 &&
      newErrors.constructor === Object
    ) {
      return true
    } else {
      setClientErrors(newErrors)
      setLoading(false)
      return false
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Input
        autocomplete="email"
        error={errors.email}
        label="Email"
        value={email}
        name="email"
        onChange={(e) => {
          if (errors) dispatch(clearErrors())
          setEmail(e.target.value)
        }}
        type="email"
        required
      />

      <Input
        autocomplete="username"
        error={errors.username}
        label="Username (2-20 characters)"
        maxLength={15}
        value={username}
        name="username"
        onChange={(e) => {
          if (errors) dispatch(clearErrors())
          setUsername(e.target.value.replace(/[^\w-]/gi, ''))
        }}
        required
      />

      <Input
        autocomplete="new-password"
        error={errors.password}
        label="Password (6-20 characters)"
        maxLength={20}
        value={password}
        name="password"
        type="password"
        onChange={(e) => {
          if (errors) dispatch(clearErrors())
          setPassword(e.target.value)
        }}
        required
      />

      <Input
        autocomplete="new-password"
        error={errors.verify}
        label="Verify your password"
        maxLength={20}
        value={verify}
        name="verify"
        type="password"
        onChange={(e) => {
          if (errors) dispatch(clearErrors())
          setVerify(e.target.value)
        }}
        required
      />

      <Button loading={loading} type="submit">
        Sign up
      </Button>
    </form>
  )
}

export default SignupPage
